import * as actions from "../action.constants";

const initialState = {
  isLoading: false,
  sitesData: {},
  locations: [],
  selectedLocation: undefined,
};

const storeSitesDetails = (state, action) => {
  return {...state, sitesData: action.payload || {}};
};

const selectedSite = (state, action) => {
  return {...state, currentSite: action.selectedSite};
};
const storeLocations = (state, action) => {
  return {...state, locations: action.payload};
};

const storeSelectedLocation = (state, action) => {
  return {...state, selectedLocation: action.payload};
};

const handlers = {
  [actions.STORE_SITES]: storeSitesDetails,
  [actions.STORE_SELECTED_SITE]: selectedSite,
  [actions.STORE_LOCATIONS]: storeLocations,
  [actions.STORE_SELECTED_LOCATION]: storeSelectedLocation,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
